<template>
  <div  class="Offline_training">
    <div ref="content" class="certificate" id="myElement">
      <img v-if="imgurl" :src="imgurl" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 0;">
      <img v-else src="../../assets/30eb4ceb3e62c23bc90bf7b3a065922.png" alt="" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 0;">
      <div style="position: relative;z-index: 2;">
        <img style="width: 40px;height: 40px;margin-top:40px;margin-left:32px;" src="../../assets/26e55c391edca1734eda330566f9810.png" alt="">
        <h3 style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:-42px;font-size: 13px;">中国科学院大学心理健康教育中心</h3>
        <p  style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:0px;font-size: 10px;">Mental Health Education Center, UCAS</p>
        <h2 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 34px;letter-spacing:1px">课程证书</h2>
        <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">Certificate of completion</p>
        <h4 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 20px;">{{certificateContentdata.realName}}</h4>
        <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">身份证号:{{certificateContentdata.idCard}}</p>
        <p style="text-align:left;color: #fff;margin-top:10px;width: 86%;margin-left:7%;line-height:26px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">恭喜您于{{certificateContentdata.trainTime}}，参加中国科学院大学心理健康教育中心举办的 "{{certificateContentdata.trainName}}"集中学习，按规定修完教学计划的全部内容，完成{{certificateContentdata.lessonHours}}学时。</p>
        <p style="text-align:left;color: #fff;margin-top:10px;margin-left:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">特发证书</p>
        <h5 style="text-align:right;color: #fff;margin-top:30px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;letter-spacing:1px">中国科学院大学心理健康教育中心</h5>
        <p style="text-align:right;color: #fff;margin-top:10px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">{{formatChineseDateTime(new Date())}}</p>
      </div>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="padding: 15px;background-color: #fff;position: relative;z-index: 999;">
      <el-form-item label="培训主题">
        <el-input v-model="formInline.name" placeholder="培训主题"></el-input>
      </el-form-item>
      <el-form-item label="时间段">
        <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.time"  type="daterange"  range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="height: 15px;background-color: rgb(235, 236, 237);position: relative;z-index: 999;"></div>
    <div class="nav" style="position: relative;z-index: 999;">
      <el-table :data="tableData" style="width: 100%;min-height:800px;">
        <el-table-column prop="trainName" label="培训主题" width="180"></el-table-column>
        <el-table-column prop="trainStartTime" label="时间" width="180"></el-table-column>
        <el-table-column prop="trainAddress" label="地点"></el-table-column>
        <el-table-column prop="enrollCount" label="已报名"></el-table-column>
        <el-table-column prop="signCount" label="已签到"></el-table-column>
        <el-table-column prop="createBy" label="创建人"></el-table-column>
        <el-table-column prop="trainObjId" label="培训院系"></el-table-column>
        <el-table-column prop="roleName" label="培训角色"></el-table-column>
        <el-table-column label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
              <span class="w" @click="looks(scope.row.trainId)">详情</span>
              <!-- <span class="w" @click="delfun(scope.row.trainId,'null',1)">删除</span> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange"
        :current-page.sync="formInline.pageNum" :page-size="10" layout="total, prev, pager, next" :total="Counts">
      </el-pagination>
    </div>
    <el-drawer :visible.sync="drawer" size="70%" :with-header="false" v-loading="Certificateissuanceload" element-loading-text="证书颁发中···，请不要进行其他操作！">
      <el-form :inline="true" class="demo-form-inline" style="padding: 15px;background-color: #fff;">
        <el-form-item label="姓名">
          <el-input v-model="name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="颁发状态">
          <el-select v-model="issue" clearable placeholder="请选择活动区域">
            <el-option label="全部"   value=""></el-option>
            <el-option label="已颁发" value="1"></el-option>
            <el-option label="未颁发" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(2)">查询</el-button>
          <el-button type="primary" @click="allfun(2)">选中颁布</el-button>
          <el-button type="primary" @click="allfun(3)">一键颁发</el-button>
        </el-form-item>
      </el-form>


      <el-table 
      :data="tableData2" 
      v-loading="certificateload" 
      :cell-style="{'text-align':'center'}" 
      @selection-change="handleSelectionChange" 
      row-key="userID"
      :default-expand-all="false"
      :tree-props="{children:'signList', hasChildren: 'hasChildren3'}"
      class="table-tree">
        <el-table-column type="selection"  width="55" :selectable="handleDisable"></el-table-column>
        <el-table-column prop="realName" label="姓名"></el-table-column>
        <el-table-column prop="trainName" label="培训主题"></el-table-column>
        <el-table-column prop="signTime" label="签到次数/时间">
          <template slot-scope="scope">
            <span v-if="Array.isArray(scope.row.signList) && scope.row.signList.length > 0">{{ scope.row.signCount }}</span>
            <span v-else>{{ scope.row.signTime }}</span> 
          </template>
        </el-table-column>
        <el-table-column prop="signOut" label="签退次数/时间">
          <template slot-scope="scope">
            <span v-if="Array.isArray(scope.row.signList) && scope.row.signList.length > 0">{{ scope.row.signOutCount }}</span>
            <span v-else>{{ scope.row.signOut }}</span> 
          </template>
        </el-table-column>
        <el-table-column prop="trainMethod" label="方式">
          <template slot-scope="scope">
            <span v-if="scope.row.trainMethod == '2'">线下</span>
          </template>
        </el-table-column>
        <el-table-column prop="trainMethod" label="证书状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '1' && Array.isArray(scope.row.signList) && scope.row.signList.length > 0">已颁发</span>
            <span v-else-if="scope.row.status != '1' && Array.isArray(scope.row.signList) && scope.row.signList.length > 0">未颁发</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-popconfirm title="是否确认删除？" @confirm="delfun(scope.row.trainId,scope.row.userID,2)">
              <el-button type="text" style="color:red" slot="reference">删除</el-button>
            </el-popconfirm>
            <span class="w" v-if="scope.row.status == '0'" @click="allfun(1,scope.row)">通过</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-bottom: 80px;" @current-change="handleCurrentChange2" :current-page.sync="pageNum" :page-size="10" layout="total, prev, pager, next" :total="Counts2">
      </el-pagination>
    </el-drawer>


    

    
    <el-dialog title="提示" :visible.sync="awardload"  width="30%" >
      <span>正在颁发，请不要进行其他操作！</span>

    </el-dialog>


  </div>
</template>
<script>
import html2canvas from 'html2canvas'
export default ({
  components: { html2canvas },
  data(){
    return{
      dialogVisible:true,
      formInline: {
        name: '',
        time: '',
        pageNum: 1,
        pageSize: '10',
      },
      name:'',
      issue:'',
      tableData:[],
      tableData2: [],
      Counts:0,
      Counts2:0,
      drawer: false,
      pageNum:1,
      trainId:'',
      certificateload:false,
      awardload:false,
      xzbbfunload:false,
      tgfunload:true,
      certificateContentdata:{},
      file64:'',
      fornum:1,
      fornum2:1,
      alluid:[],
      imgurl:'',
      RemainingQuantity:0,
      Certificateissuanceload:false,
      formData:new FormData(),
      formDateDetail:[]
    }
  },
  watch:{
    drawer(newval,oldval){
      if(!newval){
        this.pageNum=1;
      }
    },
    RemainingQuantity(newval,oldval){
      if(newval != 0 && newval <= this.alluid.length){
        this.certificateContentdata = {
          ...this.certificateContentdata,
          realName: this.alluid[newval - 1].realName,
          idCard: this.alluid[newval - 1].idCard,
          trainTime: this.alluid[newval - 1].trainTime,
          trainName: this.alluid[newval - 1].trainName,
          lessonHours: this.alluid[newval - 1].lessonHours,
        };
        this.$nextTick(() => {
          html2canvas(this.$refs.content, { dpi:72, scale:2, useCORS: true }).then(canvas => {
            const img = canvas.toDataURL("image/jpeg");
            const file = this.base64ToFile(img, this.alluid[newval-1].userID);
            this.formData.append(`images`,file);
            let DateList={
                stuID: this.alluid[newval-1].userID,
                trainId: this.alluid[newval-1].trainId,
                certUrl: '',
                certType: '1',
                examMethod: '2'
            }
            this.formDateDetail.push(DateList);
            this.RemainingQuantity++;
          });
        });
      }else if(newval > this.alluid.length){
        this.formData.append(`enrollData`,JSON.stringify(this.formDateDetail));
        this.uploadCert();
      }
    }
  },
  created() {
    this.loading();
  },
  methods:{
    uploadCert(){
      this.$Http_Post('edu/app/uploadCert',this.formData).then((res) => {
        this.Certificateissuanceload = false;
        this.formDateDetail = [];
        this.formData = new FormData();
        this.RemainingQuantity = 0;
        if(res.Code == 200 || res.Code == 0){
          this.loading2();
          this.Global.request_successful(res.Message);
        }else{
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleDisable(row){
      if (row.status==0) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(e){
      this.alluid=e;
    },

    // 一键颁发
     allfun(type,row) {
      if(type == 1){
        this.alluid=[row];
      }else if(type == 2){
        if (this.alluid.length==0) {
          this.$message.warning('请选择需要颁发的学员');
          return;
        }
      }else if(type == 3){
        this.alluid = this.offlineApplicationDetails.filter(element => element.status == 0); // 提取 userID
        if (this.RemainingQuantity>=this.alluid.length || this.alluid.length == 0) {
          this.$message.warning('已颁发完成');
          return;
        }
      }
      this.Certificateissuanceload = true;
      this.RemainingQuantity++
    },

    onSubmit(type) {
      if(type == 1){
        this.formInline.pageNum = 1;
        this.loading();
      }else{
        this.pageNum = 1;
        this.loading2();
      }
    },
    formatChineseDateTime(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return `${year}年${month}月`;
    },
    base64ToFile (base64Data,userID){
      // 将base64的数据部分提取出来
      const arr = base64Data.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // 将Uint8Array转换为Blob对象
      const blob = new Blob([u8arr], { type: mime });
      // 创建File对象
      const file = new File([blob], userID + '.jpg', { type: mime });
      return file;
    },
    loading(){
      this.certificateload = true;
      this.$Http_Post('edu/train/offlineApplication',{pageNum:this.formInline.pageNum,pageSize:this.formInline.pageSize,name:this.formInline.name,trainStartTime:this.formInline.time[0],trainEndTime:this.formInline.time[1]}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.certificateload = false;
          this.Counts = res.Counts;
          this.tableData = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    loading2(){
      this.certificateload = true;
      this.$Http_Post('edu/train/offlineApplicationDetails',{pageNum:this.pageNum,pageSize:10,name:this.name,trainId:this.trainId,issue:this.issue,type:1}).then((res) => {
        this.awardload = false;
        if (res.Code == 200 || res.Code == 0) {
          this.tableData2=res.Data.map(item=>{
           if(item.signList.length>0){
            item.signList.map(item2=>{
              item2.userID=item2.userID+'0';
              return item2;
            })
           }
           return item;
          })
          this.certificateload = false;
          this.Counts2 = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      this.$Http_Post('edu/train/offlineApplicationDetails',{pageNum:this.pageNum,pageSize:10,name:this.name,trainId:this.trainId,issue:this.issue,type:2}).then((res) => {
        this.awardload = false;
        this.certificateload = false;
        if (res.Code == 200 || res.Code == 0) {
          this.offlineApplicationDetails=res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    
    handleCurrentChange(val) {
      this.loading();
    },
    handleCurrentChange2(val) {
      this.loading2();
    },
    looks(val){
      this.drawer = true;
      this.trainId = val;
      this.loading2();
    },
    delfun(trainId,userID,type){
      this.$Http_Post('edu/train/delOfflineApplication',{trainId:trainId,type:type,userID:userID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          if(type == 1){
            this.loading();
          }else{
            this.loading2();
          }
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  mounted(){
    this.$Http_Post('/certificateTemplate/selected',{templateType:2}).then((res)=>{
      if (res.Code == 200 || res.Code == 0) {
        let originalUrl= res.Data.templateBack;
        this.imgurl=originalUrl.replace(':8095', ':8020')
        document.getElementById("myElement").style.backgroundImage = `url(${this.imgurl})`;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  }
})
</script>

<style>
  .Offline_training {width: 100%;height: 100%;}
  .Offline_training .nav{padding:15px;background-color:#fff;height:calc(100% - 140px);overflow:auto;}
  .certificate{width:320px;height:649px;position:fixed;top:110px;left:300px;background-size:100% 100%;background-image: url('../../assets/30eb4ceb3e62c23bc90bf7b3a065922.png');}
  .Offline_training .table-tree{width:calc(100% - 30px);padding:15px;}
  .Offline_training .table-tree table tr td:nth-child(2){text-align: left!important;}
</style>